/**
 * 목업 플랜의 주간 보고.
 * 기준일과 그 앞 주, 두세 주를 마감본으로 둔다. 화면의 「없음」은 이것을 가리기만 한다.
 */
import { addDays, type ISODate } from "@/engine/date";
import type { Project, UserResource } from "@/engine/types";
import { buildReportFromDraft, seedPmNames, seedWeeklyDraft } from "./weekly-draft";
import { findWeeklySnapshot, freezeWeeklyReport } from "./weekly-snapshot";

const WEEK_COUNT = 3;

function reportAuthor(project: Project, resources: Record<string, UserResource>): string {
  const { vendorPm } = seedPmNames(project, resources);
  return vendorPm && vendorPm !== "—" ? vendorPm : "나";
}

/** 기준일부터 일주일씩 거슬러 최대 세 주를 마감한다. 플랜 시작보다 앞은 두지 않는다. */
export function attachSampleWeeklyReports(project: Project, resources: Record<string, UserResource>): Project {
  const author = reportAuthor(project, resources);
  let next = project;
  for (let offset = WEEK_COUNT - 1; offset >= 0; offset -= 1) {
    const statusDate = addDays(project.statusDate, -7 * offset) as ISODate;
    if (statusDate < project.start) continue;
    if (findWeeklySnapshot(next, statusDate, statusDate)) continue;
    const draft = seedWeeklyDraft(next, resources, statusDate, author);
    const closedAt = `${statusDate}T09:00:00.000Z`;
    const report = buildReportFromDraft(draft, next, closedAt);
    next = freezeWeeklyReport(next, {
      id: `wsnap_${project.id}_${statusDate}`,
      weekId: statusDate,
      statusDate,
      periodLabel: draft.periodLabel,
      report,
      closedAt,
    }).project;
  }
  return next;
}
